/**
 * Convert a relative URI to an absolute URL.
 *
 * @example `/why-charter` -> `https://www.{DOMAIN_NAME}/why-charter`
 */
export const getAbsoluteUrl = (relativeUri: string) => `https://www.${process.env.DOMAIN_NAME}${relativeUri}`;
